import React from 'react';
import { Field, useFormikContext } from 'formik';
import { AutoCompleteSelectUI, CheckboxUI, FormErrorUI, FormLabelUI, InputUI } from '../Interface';
import { ElectronicInvoiceMethod, electronicInvoiceMethodOptions } from '../../config/electronicInvoice';

const serverFields = [
  ['eszignoServerUrl', 'e-Szignó szerver alapcíme', 'text'],
  ['eszignoServerProfileId', 'Aláíróprofil azonosítója', 'text'],
  ['eszignoServerUsername', 'API-felhasználónév', 'text'],
  ['eszignoServerPassword', 'API-jelszó', 'password'],
  ['eszignoServerTimeoutMs', 'Időkorlát (ms)', 'number'],
];

const DigitalSigningSettingFields = ({ viewField }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="col-span-6">
        <CheckboxUI
          label="Elektronikus számlázás engedélyezése"
          checked={values.digitalSigningEnabled ?? false}
          onCheckedChange={(checked) => setFieldValue('digitalSigningEnabled', checked)}
          disabled={viewField}
        />
      </div>
      {values.electronicInvoiceMethod === ElectronicInvoiceMethod.ESZIGNO &&
        serverFields.map(([name, label, type]) => (
          <div key={name} className="md:col-span-3 col-span-6">
            <Field
              name={name}
              type={type}
              as={InputUI}
              value={values[name] ?? ''}
              fullWidth
              variant="standard"
              label={<FormLabelUI text={label} />}
              helperText={<FormErrorUI message={errors[name]} />}
              disabled={viewField}
              InputLabelProps={{ shrink: true }}
            />
          </div>
        ))}
      <div className="col-span-6">
        <Field
          name="electronicInvoiceMethod"
          component={AutoCompleteSelectUI}
          fullWidth
          variant="standard"
          label={<FormLabelUI text="Elektronikus számlázási módszer" />}
          helperText={<FormErrorUI message={errors.electronicInvoiceMethod} />}
          disabled={viewField}
          selectedValue={values.electronicInvoiceMethod}
          selectedLabelValue={
            electronicInvoiceMethodOptions.find((option) => option.value === values.electronicInvoiceMethod)?.label ??
            ''
          }
          dataset={electronicInvoiceMethodOptions}
          onChange={(_event, option) => setFieldValue('electronicInvoiceMethod', option?.value ?? null)}
        />
      </div>
      <div className="col-span-6">
        <CheckboxUI
          label="Automatikus hash küldés"
          checked={values.electronicInvoiceAutoSendHash ?? false}
          onCheckedChange={(checked) => setFieldValue('electronicInvoiceAutoSendHash', checked)}
          disabled={viewField}
        />
      </div>
      <div className="col-span-6">
        <CheckboxUI
          label="APEH XML-melléklet készítése"
          checked={values.electronicInvoiceGenerateXml ?? false}
          onCheckedChange={(checked) => setFieldValue('electronicInvoiceGenerateXml', checked)}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default DigitalSigningSettingFields;
